const appBarLinks = [
  {
    name: ['Home'],
    url: 'https://v2ymvp2q5n.onrocket.site/',
    active: false,
  },
  {
    name: ['About', 'North American®'],
    url: 'https://v2ymvp2q5n.onrocket.site/about-north-american/',
    active: false,
  },
  {
    name: ['Secure', 'Horizon IUL'],
    url: 'https://v2ymvp2q5n.onrocket.site/secure-horizon-iul/',
    active: false,
  },
  {
    name: ['SecureStage'],
    url: 'https://v2ymvp2q5n.onrocket.site/secure-stage/',
    active: false,
  },
  {
    name: ['Index & Strategy', 'Options'],
    url: '#',
    subLinks: [
      {
        name: ['Diversified Index Options'],
        url: 'https://v2ymvp2q5n.onrocket.site/diversified-index-options/',
      },
      {
        name: ['Index Crediting Methods'],
        url: 'https://v2ymvp2q5n.onrocket.site/index-crediting-methods/',
      },
      {
        name: ['S&P 500® Price Index'],
        url: 'https://v2ymvp2q5n.onrocket.site/sp-500-price-index-page/',
      },
      {
        name: ['Research Affiliates®', 'Global Multi-Asset Index'],
        url: 'https://v2ymvp2q5n.onrocket.site/research-affiliates-global-multi-asset-index/',
      },
      {
        name: ['S&P PRISM® Index'],
        url: ' https://v2ymvp2q5n.onrocket.site/sp-prism-index/',
      },
    ],
    active: false,
  },
  {
    name: ['Social Security', 'Reduction', 'Estimator'],
    url: '',
    active: false,
  },
];

const LOGO_URL = 'https://www.securehorizonannuity.com/';

const ESTIMATED_BENEFITS = {
  POTENTIAL: 'Potential Reduction',
  MONTHLY: 'Monthly Reduction',
  LIFETIME: 'Lifetime Reduction',
};

const FILING_STATUS = {
  SINGLE: 'single',
  JOINT: 'joint',
};

const WIZARD_QUESTIONS = {
  AGES: {
    SINGLE: 'What is your age?',
    JOINT: 'What are your ages?',
  },
  MONTHLYSSBENEFITS: {
    SINGLE: 'What is your monthly Social Security benefit?',
    JOINT: 'What are your monthly Social Security benefits?',
  },
  STARTAGE: {
    SINGLE: 'What is your Social Security start age?',
    JOINT: 'What are your Social Security start ages?',
  },
  SSBENEFITSTARTAGE: {
    SINGLE:
      'The age you started or will start receiving Social Security benefits.',
    JOINT:
      'The age you and your spouse started or will start receiving Social Security benefits.',
  },
};

const WIZARD_MAXMIN = {};
const CURRENT_AGE = {
  MAX: 79,
  MIN: 40,
};
const SPOUSE_CURRENT_AGE = {
  MAX: 79,
  MIN: 40,
};
const SOCIAL_SECURITY_START_AGE = {
  MAX: 70,
  MIN: 62,
};
const SPOUSE_SOCIAL_SECURITY_START_AGE = {
  MAX: 70,
  MIN: 62,
};
const INITIAL_SOCIAL_SECURITY_BENEFIT = {
  MAX: 11500,
  MIN: 1,
};
const SPOUSE_INITIAL_SOCIAL_SECURITY_BENEFIT = {
  MAX: 11500,
  MIN: 1,
};
const POTENTIAL_REDUCTION_ESTIMATED = {
  MAX: 21,
  MIN: 1,
};

const DOWNLOAD_BROCHURE_URL = 'https://nash-iul.s3.us-west-1.amazonaws.com/1822NM-PlanGap-Benefit-Brochure.pdf';
const LEARN_MORE_SECURE_HORIZON_URL = 'https://v2ymvp2q5n.onrocket.site/';

export {
  ESTIMATED_BENEFITS,
  appBarLinks,
  FILING_STATUS,
  WIZARD_QUESTIONS,
  WIZARD_MAXMIN,
  CURRENT_AGE,
  SPOUSE_CURRENT_AGE,
  SOCIAL_SECURITY_START_AGE,
  SPOUSE_SOCIAL_SECURITY_START_AGE,
  INITIAL_SOCIAL_SECURITY_BENEFIT,
  SPOUSE_INITIAL_SOCIAL_SECURITY_BENEFIT,
  POTENTIAL_REDUCTION_ESTIMATED,
  DOWNLOAD_BROCHURE_URL,
  LEARN_MORE_SECURE_HORIZON_URL,
  LOGO_URL,
};
